import { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useAppDispatch } from "../../store/store";
import { addThirdPartyDeviceThunk, getThirdPartyDevices } from "../../store/thunk/thirdPartyDeviceThunk";

export default function AddDeviceDialog({ open, handleClose, selectedProvider }: { open: boolean; handleClose: () => void, selectedProvider: any }) {
    const [newDeviceId, setNewDeviceId] = useState("");
    const [deviceIdError, setDeviceIdError] = useState("");
    const [newDeviceName, setNewDeviceName] = useState("");
    const [deviceNameError, setDeviceNameError] = useState("");
    const [loader, setLoader] = useState(false);
    const dispatch = useAppDispatch();
    const handleConfirmAddDevice = async () => {
        if (!newDeviceId.trim()) {
            setDeviceIdError("Device ID is required");
            return;
        }
        if (!newDeviceName.trim()) {
            setDeviceNameError("Device Name is required");
            return;
        }

        setLoader(true);
        // Simulate API call

        const request = {
            deviceId: newDeviceId.trim(),
            deviceName: newDeviceName.trim(),
            providerId: selectedProvider?.sk
        };
        try {
            const result = await dispatch(addThirdPartyDeviceThunk(request)).unwrap();
            if (result) {
                console.log("Device added successfully:", result);
                await dispatch(getThirdPartyDevices({ providerId: selectedProvider?.sk }));
                setNewDeviceId("");
                setNewDeviceName("");
                handleClose()
            }
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.error("Failed to add device:", error);
            // Optionally, display an error notification to the user
        }
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle sx={{ marginBottom: 0 }}>Add New Device</DialogTitle>
            <DialogContent sx={{ py: 1 }}>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Device ID"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={newDeviceId}
                    onChange={(e) => {
                        setNewDeviceId(e.target.value);
                        if (e.target.value.trim()) setDeviceIdError("");
                    }}
                    error={Boolean(deviceIdError)}
                    helperText={deviceIdError}
                />
                <TextField
                    margin="dense"
                    label="Device Name"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={newDeviceName}
                    onChange={(e) => {
                        setNewDeviceName(e.target.value);
                        if (e.target.value.trim()) setDeviceNameError("");
                    }}
                    error={Boolean(deviceNameError)}
                    helperText={deviceNameError}
                />
            </DialogContent>
            <DialogActions sx={{ paddingBottom: 2, paddingRight: 3 }}>
                <Button onClick={handleClose} variant="outlined" color="primary">
                    Cancel
                </Button>
                <LoadingButton loading={loader} onClick={handleConfirmAddDevice} variant="contained" color="secondary">
                    Add
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
